import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_HELP';

const en = {
    ok: 'Ok',
    help: 'Help',
    formHelp: 'Form Help',
    documents: 'Documents',
    faqs: "FAQ's",
    videos: 'Videos',
    viewAll: 'View All',
    back: 'Back',
    footerText: 'Open in Priority Xpert',
    showMore: 'Read More',
    showLess: 'Read Less',
    emptyStateTitle: 'We could not find any help for this form.',
    emptyStateTextBlink: 'Visit',
    emptyStateTextAlink: ' for more help options',
    emptyStateLink: 'Priority Xpert',
    emptyStateXpertTitle: 'We could not find further help for this form.',
    emptyStateSearchTitle: "We could not find any matches for 'XXX'",
    emptyStateSearchTextBlink: 'Check your spelling, or try different keywords. \nVisit ',
    emptyStateSearchTextAlink: ' for more help options',
    inputListPlaceholder: 'Search FAQs',
    inputMainPlaceholder: 'Search Form Help',
    helpButtonTooltip: 'Form help and relevant videos, SOPs, and FAQs.',
    xpertErrorTitle: 'Access to Priority Xpert was stopped.',
    xpertErrorText:
        'It appears you have no access to an external network or you have no access permission. Please contact your system administrator'
};

const he = {
    ok: 'אישור',
    help: 'עזרה',
    formHelp: 'עזרה למסך',
    documents: 'מסמכים',
    faqs: 'שאלות ותשובות',
    videos: 'סרטונים',
    viewAll: 'הצג הכל',
    back: 'חזור',
    footerText: 'פתיחה באתר Priority Xpert',
    showMore: 'לקרוא עוד',
    showLess: 'להראות פחות',
    emptyStateTitle: 'נראה שאין כרגע עזרה למסך',
    emptyStateTextBlink: 'כדאי להיכנס לאתר ',
    emptyStateTextAlink: ' עבור אפשרויות עזרה אחרות.',
    emptyStateLink: ' Priority Xpert ',
    emptyStateXpertTitle: 'נראה שאין עזרה נוספת.',
    emptyStateSearchTitle: 'לא מצאנו תוצאות לחיפוש "XXX"',
    emptyStateSearchTextBlink:
        ' כדאי לבדוק את האיות, או להשתמש במילות מפתח אחרות. אפשר גם להיכנס לאתר ',
    emptyStateSearchTextAlink: ' לעזרה נוספת. ',
    inputListPlaceholder: 'חיפוש בשאלות ותשובות',
    inputMainPlaceholder: 'חיפוש בתוצאות העזרה',
    helpButtonTooltip: 'עזרה למסך, סרטונים, הוראות הפעלה ו-FAQs רלוונטיים.',
    xpertErrorTitle: 'הגישה ל-Priority Xpert נעצרה.',
    xpertErrorText:
        'כנראה שאין כרגע גישה לרשת חיצונית או שחסרות לך השראות מתאימות. אפשר לפנות למנהל/ת המערכת בנושא. '
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'ok',
    2: 'help',
    3: 'formHelp',
    4: 'documents',
    5: 'faqs',
    6: 'videos',
    7: 'viewAll',
    8: 'back',
    9: 'footerText',
    10: 'showMore',
    11: 'showLess',
    12: 'emptyStateTitle',
    13: 'emptyStateTextBlink',
    14: 'emptyStateTextAlink',
    15: 'emptyStateLink',
    16: 'emptyStateXpertTitle',
    17: 'emptyStateSearchTitle',
    18: 'emptyStateSearchTextBlink',
    19: 'emptyStateSearchTextAlink',
    20: 'inputListPlaceholder',
    21: 'inputMainPlaceholder',
    22: 'helpButtonTooltip',
    23: 'xpertErrorTitle',
    24: 'xpertErrorText'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
